import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function truncateMiddle(text: string, maxLength: number) {
  if (text.length <= maxLength) return text

  const half = maxLength / 2
  return `${text.slice(0, half)}...${text.slice(-half)}`
}

export function getDateFromMinutes(minutes: number): Date {
  const hours = Math.floor(minutes / 60)
  const mins = minutes % 60
  const date = new Date()
  date.setHours(hours, mins, 0, 0)
  return date
}
